import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import template from './GDPRSection.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { AddressTypes as Types } from "../../_loadingHelpers/Address";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import MultiselectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';

class GDPRSection extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private entityId: string = null;
    private store: MdsLax<InstanceType<typeof EntityStore<Types.GDPRAssignment>>>;

    private entityViewContainer: HTMLElement;
    private entityView: MdsLax<InstanceType<typeof GenericEntityView>>;

    private note: HTMLElement;
    //private note: Edit;

    private assignments: MdsLax<InstanceType<typeof MultiselectBox>>;

    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private tableEntryList: Array<Types.GDPRAssignment> = [];


    constructor(entityId?: string) {
        super(...(arguments as unknown as []));
        if (entityId) this.entityId = entityId;
    }

    private emitDataChanged() {

        let data = this.store.getDiffData();

        this.emit("GDPR_DataChanged", data);
    }

    private refreshData() {

        this.updateTable();
    }

    private _onChange_Assignments(selectedIds: Array<string>) {

        let newEntries = this.store.getCurrentCompleteValueList("new");

        newEntries.forEach(e => {
            if (selectedIds.indexOf(e) == -1) this.store.deleteEntry(e);
        })

        this.tableEntryList.forEach(e => {
            if (selectedIds.indexOf(e.ref_GDPR_template.ID) == -1) {
                e.toDelete = true;
                this.store.changeEntry(e);
            }
            else if (e.toDelete == true) {
                e.toDelete = false
                this.store.changeEntry(e);
            };
            
        })

        let selectedTemplates: Array<Types.GDPRTemplate> = this.assignments.getValue(true);
        let storeEntries = this.store.getCurrentCompleteList();

        selectedTemplates.forEach(t => {

            if (storeEntries.filter(x => x.ref_GDPR_template.ID === t.ID).length == 0) {

                let newId = (Math.random() * 100000).toString();
                let fakeNewEntry: Partial<Types.GDPRAssignment> = {
                    ID: newId,
                    ref_GDPR_template: t,
                    isNew: true,
                }
                this.store.addEntry(fakeNewEntry as any, "new");
            }
        })

        this.updateTable();
        this.emitDataChanged();
    }

    private updateTable() {

        this.table.setupFromStore(this.store);
        this.emit("GDPR_TableUpdate", this.tableEntryList.length > 0);

        this.hourGlassStart(this.table);
        setTimeout(() => {
            this.tableEntryList?.forEach(d => {
                if (d.toDelete === true) {
                    let node = this.table.getRowGroupByKeyValue(d.ID, "ID").rows[0].node;
                    this.disableNode(node);
                }
            });
            this.hourGlassEnd(this.table);
        }, 200);
    }

    private loadGDPRData() {

        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard__GDPR_GetData",
            { entityId: this.entityId },
            lang.hitch(this, this.onLoadGDPRDataResponse),
            lang.hitch(this, this._showErrorMessage)
        );
    }

    private onLoadGDPRDataResponse(response: Types.GDPRGetDataResponse) {
        let preset = [];

        if (response.entityView) {

            let view = new GenericEntityView();
            view.setupWithoutEntity(response.entityView, "label", this.entityViewContainer);

            this.store.setup(response.tableList);

            response.tableList.forEach(a => {

                preset.push(response.templates.filter(t => t.ID === a.ref_GDPR_template.ID)[0]);
            })

            this.tableEntryList = response.tableList;
        }        
        
        this.assignments.setData(preset, response.templates, true);

        this.table = new StaticTable();
        this.table.placeAt(this.tableContainer);
        this.table.setLayout(response.tableLayout);

        if (response.isReadonly) {

            this.assignments.setReadonly(true);
        }

        this.updateTable();

        this.table.setCyAttribute("GDPRSection");

        this.StandbyStop();
    }

    private _showErrorMessage(err?: more.requestErrorMessage | string) {
        let msg;

        if (typeof err == "string") msg = err;
        else msg = err ? err.Message : "...error occured";

        this.showToast(msg, "fas fa-exclamation-triangle");
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.StandbyStart();
        this.store = new EntityStore();
        this.loadGDPRData();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(GDPRSection);